import React, { useState } from 'react';

interface InputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'password' | 'tel';
  error?: boolean;
  disabled?: boolean;
  className?: string;
}

export const CustomInput: React.FC<InputProps> = ({
  placeholder,
  value,
  onChange,
  type = 'text',
  error = false,
  disabled = false,
  className = '',
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`relative w-full ${className}`}>
      <div
        className={`relative bg-white rounded-2xl p-4 shadow-sm border transition-all duration-200 ${
          error ? 'border-borderRed' : 'border-primaryBg'
        } ${isFocused ? 'border-darkGreen shadow-md' : ''}`}
      >
        <label
          className={`absolute left-4 transition-all duration-200 pointer-events-none text-placeholderColor ${
            isFocused || value
              ? 'top-1 text-xs'
              : 'top-1/2 transform -translate-y-1/2 text-base'
          }`}
        >
          {placeholder}
        </label>
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          className={`w-full bg-transparent text-black text-base outline-none ${
            isFocused || value ? 'pt-4 pb-0' : 'py-2'
          } ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
        />
      </div>
    </div>
  );
};